import { render } from "./ClipLoader.vue?vue&type=template&id=2805131e&scoped=true"
import script from "./ClipLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./ClipLoader.vue?vue&type=script&setup=true&lang=js"

import "./ClipLoader.vue?vue&type=style&index=0&id=2805131e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2805131e"],['__file',"src/components/ui/ClipLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2805131e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2805131e', __exports__)) {
    api.reload('2805131e', __exports__)
  }
  
  module.hot.accept("./ClipLoader.vue?vue&type=template&id=2805131e&scoped=true", () => {
    api.rerender('2805131e', render)
  })

}


export default __exports__